import table from "../assets/table-2026.svg"

export const SponsorTable = () => {
  return (
    <div className="sponsor-table">
      <img src={table} alt="Sponsorship Tiers" />
    </div>
  )
}
